import { Component, signal } from '@angular/core';

@Component({
  selector: 'rid-audio-bubble',
  imports: [],
  templateUrl: './rid-audio-bubble.html',
  styleUrl: './rid-audio-bubble.css',
  host: {
    class: 'block size-full',
  },
})
export class RidAudioBubble {
  bubbles = signal<number[]>([]);

  public play() {
    this.bubbles.update((bubbles) => [...bubbles, Math.random()]);
  }

  protected remove(bubble: number) {
    this.bubbles.update((bubbles) => bubbles.filter((b) => b !== bubble));
  }
}
